<div style="display: flex; justify-content: space-between; align-items: center; margin: 20px 20px 0 20px">
  <h1>Enlaces diseño</h1>

  @if (canEditDesignLinks) {
    <button mat-stroked-button (click)="openCreateTaskDesignLinkDialog()">
      <mat-icon>add</mat-icon>
      Añadir enlace
    </button>
  }
</div>

<mat-dialog-content style="padding-top: 10px">
  <div class="bisual-table">
    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource" style="overflow: scroll; width: 100%">
        <ng-container matColumnDef="link">
          <th mat-header-cell *matHeaderCellDef>Enlace</th>
          <td mat-cell *matCellDef="let designLink" style="max-width: 300px">
            <a
              href="{{ designLink.link }}"
              target="_blank"
              title="{{ designLink.link }}"
              style="display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%"
            >
              {{ designLink.link }}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="comment">
          <th mat-header-cell *matHeaderCellDef>Comentario</th>
          <td mat-cell *matCellDef="let designLink" style="word-break: break-all">
            {{ designLink.comment ?? '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>

          <td mat-cell *matCellDef="let designLink">
            <div style="display: flex; gap: 8px; align-items: center">
              <button mat-icon-button (click)="openEditTaskDesignLinkDialog(designLink)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="openDeleteTaskDesignLinkDialog(designLink)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</mat-dialog-content>
